import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';

export const AnswerIcon = () => {
    return <AutoAwesomeIcon
        sx={{ color: "rgba(115, 118, 225, 1)"}}
        aria-hidden="true"
        aria-label="Answer logo"
    />;
};
